<template>
  <master-main
    :route="getModuleRoute"
    :addProperties="{
      eventType: 1,
      routeToCreate: getModuleRoute,
    }"
    :tableProperties="tableProperties"
    :exportProperties="{
      pdf: {
        filename: `${$t('common_words.farms')}.pdf`,
        route: `${getModuleRoute}/pdf`,
      },
      xls: {
        filename: `${$t('common_words.farms')}.xlsx`,
        route: `${getModuleRoute}/excel`,
      },
    }"
    @showHideLoading="showHideLoading"
    @showNotification="notifyVue"
    @refresh="refresh"
  ></master-main>
</template>
<script>
import FarmTable from './farm-table';
import i18n from 'src/i18n';
import MasterMain from 'src/components/Layouts/Masters/MasterMain.vue';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMain from 'src/mixins/master/mixin-main';
import MixinPermissions from 'src/util/mixinPermissions';

export default {
  components: { MasterMain },
  data() {
    return {
      tableProperties: {},
      showProperties: { size: '70%' },
    };
  },
  computed: {
    getModuleRoute() {
      return 'farms/farms';
    },
    buildTableProperties() {
      return {
        tableColumns: [...FarmTable().tableColumns],
        effectTags: 'dark',
        model: 'farm',
        widthOperations: 110,
        widthColumnStatus: 160,
        map: 'loadBaseMap',
        addColumns: [
          {
            label: i18n.t('production.scales'),
            data: 'devices',
            field: 'name',
          },
          {
            label: i18n.t('common_words.companies'),
            data: 'businesses',
            field: 'name',
          },
        ],
      };
    },
  },
  mixins: [MixinAlert, MixinLoading, MixinMain, MixinPermissions],
};
</script>
